import UtilityMixin from "../../utility/UtilityMixin";
import moment from "moment";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [UtilityMixin],
	data() {
		return {
			pathResourceAccettazioneConsensi: "/accettazioneconsensi",
			pathResourceAccettazioneConsensiStati: "/accettazioneconsensistatistorico",
			accettazioneConsenso: { idAccettazione: null, idConsenso: null, nomeConsenso: null },
			accettazioneCosensiItems: [],
			accettazioneConsensiFiltro: {},
			accettazioneCosensiRows: 0,
			accettazioneCosensiFields: [
				{
					label: "",
					key: "index",
					thStyle: "width: 3rem",
				},
				{
					label: "Data Ora",
					key: "updateDate",
					formatter: (value) => {
						return moment(value).format("DD/MM/YYYY HH:mm:ss");
					},
					thStyle: "width: 15rem",
				},
				{
					label: "Consenso",
					key: "nomeConsenso",
				},
				{
					label: "Stato",
					key: "statoAttuale",
					thStyle: "width: 15rem",
				},
				{
					label: "",
					key: "actions",
					class: "sa-table-column-action-double",
				},
			],
		};
	},
	methods: {
		accettazioneConsensoNew() {
			this.accettazioneConsenso = { idAccettazione: null, idConsenso: null, nomeConsenso: null };
		},
		accettazioneConsensoSave() {
			this.saveResource(this.pathResourceAccettazioneConsensi, this.accettazioneConsenso, this.accettazioneConsensoSaveSuccess, null);
		},
		accettazioneConsensoSaveSuccess(response) {
			this.accettazioneConsenso = response.data.data;
			this.accettazioneConsensiLoadData();
		},
		accettazioneConsensiLoadData() {
			this.loadDataResources(this.pathResourceAccettazioneConsensi, this.accettazioneConsensiFiltro, this.accettazioneConsensiLoadDataSuccess, null);
		},
		accettazioneConsensiLoadDataSuccess(response) {
			this.accettazioneCosensiItems = [];
			this.accettazioneCosensiItems = response.data.data.list;
			this.accettazioneCosensiRows = response.data.data.recordsNumber;
			this.$emit("afterLoadData");
			this.closeShowModalLoading();
		},
		accettazioneConsensoCambiaStato(idAccettazioneConsenso, stato) {
			let me = this;
			this.$bvModal
				.msgBoxConfirm("Assicurarsi che il consenso sia stato firmato prima di proseguire ", {
					title: "ATTENZIONE!",
					headerClass: "bg-danger text-white",
					buttonSize: "sm",
					okVariant: "secondary",
					cancelVariant: "danger",
					okTitle: "SI",
					cancelTitle: "NO",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					if (value) {
						me.openShowModalLoading();
						let jsonStato = { idAccettazioneConsenso: idAccettazioneConsenso, stato: stato, note: "Consenso firmato in modalità cartacea" };
						this.saveResource(this.pathResourceAccettazioneConsensiStati, jsonStato, this.accettazioneConsensoCambiaStatoSuccess, null);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		accettazioneConsensoCambiaStatoSuccess() {
			this.accettazioneConsensiLoadData();
			this.closeShowModalLoading();
		},
	},
};
